import {Component} from '@angular/core';

@Component({
  selector: 'app-contractcontrolwidget',
  templateUrl: './contractcontrolwidget.component.html',
  styleUrls: ['./contractcontrolwidget.component.scss']
})
export class ContractcontrolwidgetComponent {

  constructor() {
  }
}
